<div class="gw-space-y-6 gw-p-x-large gw-max-w-md">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <p class="gw-text-text-primary gw-text-base">
      {{
        'features.settings.parameters.feeBatchMinimumAmount.description'
          | translate
      }}
    </p>
    <gatewee-input-v2
      [form]="formGroup"
      controlName="value"
      [label]="
        'features.settings.parameters.feeBatchMinimumAmount.value.label'
          | translate
      "
      id="fee-batch-min-value"
      type="decimal"
    ></gatewee-input-v2>
    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
